export default __webpack_public_path__ + "static/media/Standard31.c80ae356.png";